import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { createData } from './CharacterClasses';

const rows = [
  createData('^', 'Matches the beginning of input'),
  createData('$', 'Matches the end of input'),
  createData('\\b', 'Matches a word boundary'),
  createData('\\B', 'Matches a non-word boundary'),
];

export function Assertions() {
  return (
    <Table size="small">
      <TableHead>
        <h3>Assertions</h3>
      </TableHead>
      <TableBody>
        {rows.map(row => (
          <TableRow>
            <TableCell>{row.regex}</TableCell>
            <TableCell align="right">{row.description}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
